// src/components/tiptap/floatingMenu/FloatingPromptMenu.tsx

import { FloatingMenu } from "@tiptap/react"
import { FloatingMenuContent } from "@/components/tiptap/floatingMenu/FloatingMenuContent"
import { FloatingPromptInput } from "@/components/tiptap/floatingMenu/FloatingPromptInput"
import type { Editor } from "@tiptap/react"

export function CustomFloatingMenu({
  editor,
  onAction,
}: {
  editor: Editor
  onAction: (
    action:
      | "webSearch"
      | "docSearch"
      | "outline"
      | "idea"
      | "intro"
      | "customPrompt",
    prompt: string,
    editor: Editor
  ) => void | Promise<void>
}) {
  return (
    <FloatingMenu
        editor={editor}
        tippyOptions={{
            placement: "bottom-start",
            duration: 100,
            delay: [1000, 1000],
        }}
        shouldShow={({ editor }) => {
            const { $from } = editor.state.selection
            return $from.parent.content.size === 0
        }}
        >
        <>
            {/* Prompt input appears above the floating menu */}
            <FloatingPromptInput
                onPromptSubmit={(prompt) => onAction("customPrompt", prompt, editor)}
            />

            {/* Actual menu content below */}
            <div className="floating-menu">
            <FloatingMenuContent
                onAction={(action) => onAction(action, "", editor)}
            />
            </div>
        </>
    </FloatingMenu>
  )
}
